module.exports = __webpack_public_path__ + "img/100.480aa69e.jpg";